import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { LiveDemo } from './components/LiveDemo';
import { Features } from './components/Features';
import { Integrations } from './components/Integrations';
import { HowItWorks } from './components/HowItWorks';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#f5f5f5] selection:bg-[#ff6b35] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <LiveDemo data-id="element-4" />
        <Features data-id="element-5" />
        <Integrations data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <Pricing data-id="element-8" />
        <Testimonials data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}